import styled from "styled-components/macro";

import FnrHelpEmailLink from "UI/FnrHelpEmailLink/FnrHelpEmailLink";
import { NoticeMessage } from "UI/FnrNoticeMessage";

const SDiv = styled("div")`
  max-width: 620px;
`;

const IsClosedNetworkMessage = () => (
  <SDiv>
    <NoticeMessage>
      Family registration does not work with closed networks. Please to reach
      out to <FnrHelpEmailLink /> with any questions.
    </NoticeMessage>
  </SDiv>
);

export default IsClosedNetworkMessage;
